export function initBannerBlocks(root = document) {
  const bannerBlocks = root.querySelectorAll('.vicenza-banner');

  bannerBlocks.forEach((bannerBlock) => {
    bannerBlock.classList.add('is-ready');
  });
}

